import axios from 'axios';

// GET Retrieve latest invoice data for a specific provider and plan name
export const getLatestInvoiceData = (provider, name) => {
    return new Promise((resolve, reject) => {
        axios.get(`/invoice/getlatestdata/${provider}/${name}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// GET Retrieve all invoices
export const getAllInvoices = () => {
    return new Promise((resolve, reject) => {
        axios.get('/invoice/getall')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// GET Retrieve invoice data with filters (color and month)
export const getInvoiceData = (color, month) => {
    return new Promise((resolve, reject) => {
        axios.get(`/invoice/getdata?color=${color}&month=${month}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// GET Retrieve current month cost for a house
export const getCurrentMonthCost = (houseId) => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/cost/currentmonth/${houseId}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// GET Retrieve cost for past 30 days for a specific invoice plan
export const getPast30DaysCost = (houseId, invoiceProvider, invoiceName) => {
    return new Promise((resolve, reject) => {
        axios.get(`/data/cost/past30days/${houseId}/${invoiceProvider}/${invoiceName}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// GET Retrieve billing metadata for a house
export const getBillingMetadata = (houseId) => {
    return new Promise((resolve, reject) => {
        axios.get(`/billingmetadata/get/${houseId}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

// POST Upsert billing metadata for a house
export const upsertBillingMetadata = (houseId, metadata) => {
    return new Promise((resolve, reject) => {
        axios.post(`/billingmetadata/upsert/${houseId}`, metadata)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

